export const view = {
  RESIDUE: "qoldiq",
  INCOME: "kirim",
  OUTLAY: "chiqim",
};
